// extracted by css-extract-rspack-plugin
export default {"cls1":"step_two-cls1_qfM","cls2":"step_two-cls2_cSD step_two-cls1_qfM"};